import { useEffect, useState } from "react";
import { BuildingFacilityTagModel, BuildingFacilityTagRequest } from "src/api/building/commonfacility-types";
import { BaseButton, BaseInput } from "src/components";
import { BULLET } from "src/utils";

type Props = {
  tagDetail?: BuildingFacilityTagModel;
  onSubmit: (request: BuildingFacilityTagRequest) => Promise<void>;
  onClose: () => void;
};

const FacilityTagFormModal = ({ onSubmit, onClose, tagDetail }: Props) => {
  const [tagData, setTagData] = useState<BuildingFacilityTagRequest>({ name: "" });
  const [error, setError] = useState<string>("");
  useEffect(() => {
    if (tagDetail) {
      setTagData({ tagId: String(tagDetail.id), name: tagDetail.name, priority: tagDetail.priority });
    } else {
      setTagData({ name: "" });
    }
  }, [tagDetail]);

  return (
    <>
      <section className="base-abstract-modal__title border-bottom-gray mb20 ">
        <div className="flex-direction-column">
          <h1>태그 설정</h1>
          {tagDetail && <p className="text-primary3 font14">{BULLET} 적용된 공용공간은 그대로 유지되며, 태그명만 변경됩니다.</p>}
        </div>
      </section>
      <div className="px30">
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p className="required">태그명</p>
          </div>
          <div className="contents-container__grid-contents minmax240">
            <BaseInput
              autoFocus
              placeholder="태그명을 입력해 주세요"
              value={tagData?.name}
              onChange={(value: string) => setTagData({ ...tagData, name: value })}
            />
            {error && <p className="validation-text font14">{error}</p>}
          </div>
        </section>
      </div>

      <section className="base-abstract-modal__btn-wrap">
        <BaseButton className="color-white" title="닫기" onClick={onClose} />
        <BaseButton
          title="저장"
          onClick={() => {
            if (tagData.name.trim() === "") {
              setError("필수 입력 항목입니다.");
              return;
            }
            onSubmit(tagData);
          }}
        />
      </section>
    </>
  );
};

export default FacilityTagFormModal;
